import { PieChart, Pie, Label, Cell, ResponsiveContainer } from 'recharts';

const PieGraph = ({ data }) => {
  const { colors, items, label } = data;
  return (
    <div style={{ width: '100%', height: '100%' }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={items}
            dataKey="value"
            nameKey="name"
            outerRadius="100%"
            innerRadius="80%"
            fill="#8884d8"
            isAnimationActive={false}
            paddingAngle={-10}
            startAngle={90}
            endAngle={450}
            cornerRadius="50%"
          >
            {items.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={colors[index % colors.length]}
                style={{ stroke: 'none' }}
              />
            ))}
          </Pie>
          <Label
            position="center"
            fill="#101828"
            fontSize="30px"
            fontWeight="600"
          >
            {label}
          </Label>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PieGraph;
